<template>
    <div>
        <div class="card shadow bg-white">
            <div class="card-header h6">
                Corridoring & Geofencing
            </div>

            <!-- ===== Corridoring ===== -->
            <div v-if="balise.corridoringId" class="p-3 row align-items-center">
                <div class="col-auto">
                    <InfoDisplay icon="circle" color="green" />
                </div>
                <div class="col-auto">
                    Corridoring actif :
                </div>
                <div class="col-auto">
                    <router-link :to="'/corridoringmap/' + corridoring.id">
                        {{ corridoring.name }}
                    </router-link>
                </div>
                <div class="col-auto">
                    <ButtonDisplay type="cancel" text="Arrêter" @click="removeCorridoring()" />
                </div>
            </div>
            <div v-else class="p-3">
                <template v-if="hasCorridorings">
                    <div class="row align-items-center g-2">
                        <div class="col-auto">
                            Ajouter un corridoring :
                        </div>
                        <div class="col-12 col-md-6 col-lg-5">
                            <select v-model="newCorridoring" class="form-select w-100">
                                <option :value="null" disabled>— Sélectionner —</option>
                                <option v-for="selectCorridoring in corridorings" :key="selectCorridoring.id"
                                    :value="selectCorridoring.id">
                                    {{ selectCorridoring.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-auto">
                            <ButtonDisplay type="save" text="Activer" :disabled="!newCorridoring"
                                @click="startCorridoring()" />
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="d-flex align-items-center gap-2 mb-0">
                        <span class="text-muted">
                            Aucun corridoring disponible. Créez-en un pour pouvoir l’assigner à ce véhicule.
                        </span>
                    </div>
                </template>
            </div>

            <hr class="my-0" />

            <!-- ===== Geofencing ===== -->
            <div v-if="balise.geofencingId" class="p-3 row align-items-center">
                <div class="col-auto">
                    <InfoDisplay icon="circle" color="green" />
                </div>
                <div class="col-auto">
                    Geofencing actif :
                </div>
                <div class="col-auto">
                    <span>{{ geofencing.name }}</span>
                </div>
                <div class="col-auto">
                    <ButtonDisplay type="cancel" text="Arrêter" @click="removeGeofencing()" />
                </div>
            </div>
            <div v-else class="p-3">
                <template v-if="hasGeofencings">
                    <div class="row align-items-center g-2">
                        <div class="col-auto">
                            Associer un geofencing :
                        </div>
                        <div class="col-12 col-md-6 col-lg-5">
                            <select v-model="newGeofencing" class="form-select w-100">
                                <option :value="null" disabled>— Sélectionner —</option>
                                <option v-for="g in geofencings" :key="g.id" :value="g.id">
                                    {{ g.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-auto">
                            <ButtonDisplay type="save" text="Activer" :disabled="!newGeofencing"
                                @click="startGeofencing()" />
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="d-flex align-items-center gap-2 mb-0">
                        <span class="text-muted">
                            Aucun geofencing disponible. Créez-en un pour pouvoir l’assigner à ce véhicule.
                        </span>
                    </div>
                </template>
            </div>
            <div class="card-footer p-3 text-center">
                <router-link :to="'/corridoringlist/'">Corridorings</router-link>
                <span class="mx-2 text-muted">|</span>
                <router-link :to="'/geofencingmap'">Geofencings</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import InfoDisplay from '@/components/display/InfoDisplay.vue'
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'
import CorridoringService from '@/services/corridoring.service'
import GeofencingService from '@/services/geofencing.service'
import FormatHelper from '@/helpers/format.helper.js'

export default {
    props: ['balise'],
    components: {
        InfoDisplay,
        ButtonDisplay
    },
    data() {
        return {
            corridoring: {},
            corridorings: [],
            newCorridoring: null,
            geofencing: {},
            geofencings: [],
            newGeofencing: null,
        };
    },
    watch: {
        balise: function () {
            this.getBaliseCorridoring();
            this.getBaliseGeofencing();
        }
    },
    computed: {
        hasCorridorings() {
            return Array.isArray(this.corridorings) && this.corridorings.length > 0;
        },
        hasGeofencings() {
            return Array.isArray(this.geofencings) && this.geofencings.length > 0;
        }
    },
    mounted() {
        this.getClientCorridorings();
        this.getClientGeofencings();
        if (this.balise.corridoringId)
            this.getBaliseCorridoring();
        if (this.balise.geofencingId)
            this.getBaliseGeofencing();
    },
    methods: {
        getClientCorridorings() {
            CorridoringService.getClientCorridorings()
                .then(response => {
                    this.corridorings = FormatHelper.corridoringsFormat(response.data);
                    // réinitialise la sélection si aucun corridoring n'est disponible
                    if (!this.hasCorridorings) this.newCorridoring = null;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        getBaliseCorridoring() {
            if (!this.balise.corridoringId) return;
            CorridoringService.getCorridoring(this.balise.corridoringId)
                .then(response => {
                    this.corridoring = FormatHelper.corridoringInfoFormat(response.data);
                })
                .catch(e => {
                    console.log(e);
                });
        },
        getClientGeofencings() {
            GeofencingService.getClientGeofencings()
                .then(response => {
                    this.geofencings = FormatHelper.geofencingsFormat(response.data || []);
                    if (!this.hasGeofencings) this.newGeofencing = null;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        getBaliseGeofencing() {
            if (!this.balise.geofencingId) return;
            GeofencingService.getGeofencing(this.balise.geofencingId)
                .then(response => {
                    this.geofencing = FormatHelper.geofencingInfoFormat(response.data);
                    this.newGeofencing = this.balise.geofencingId;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        startCorridoring() {
            if (!this.newCorridoring) return;
            CorridoringService.addBalise(this.newCorridoring, this.balise.id)
                .then(() => {
                    this.$emit("refresh");
                })
                .catch(e => {
                    console.log(e);
                });
        },
        removeCorridoring() {
            CorridoringService.removeBaliseCorridoring(this.balise.id)
                .then(() => {
                    this.$emit("refresh");
                })
                .catch(e => {
                    console.log(e);
                });
        },
        startGeofencing() {
            if (!this.newGeofencing) return;
            GeofencingService.addBalise(this.newGeofencing, this.balise.id)
                .then(() => {
                    this.$emit("refresh");
                })
                .catch(e => {
                    console.log(e);
                });
        },
        removeGeofencing() {
            GeofencingService.removeBaliseGeofencing(this.balise.id)
                .then(() => {
                    this.$emit("refresh");
                })
                .catch(e => {
                    console.log(e);
                });
        },
    }
}
</script>